import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "@src/api/config";
import { apSchoolCoverage } from "@src/components/certs/ap_school/memberships/ap_school.types";

type APSchoolCoveragesState = {
  coverages: apSchoolCoverage[];
  loading: boolean;
};

export const getAPSchoolCoverages = createAsyncThunk<
  { data: any },
  void
>("apSchool/coverages", async (_, { getState }) => {
  const state = getState() as {
    products?: { productSelected?: { value?: string | number } };
    businessLines?: { businessLineSelected?: { id?: string | number } };
  };
  const product = state.products?.productSelected?.value ?? "";
  const business_line = state.businessLines?.businessLineSelected?.id ?? "";
  const response = await api.get("/api/skus", {
    params: { product, business_line }
  });
  return { data: response.data };
});

const normalizeCoverages = (payload: any): apSchoolCoverage[] => {
  if (Array.isArray(payload?.data?.data)) {
    return payload.data.data;
  }
  if (Array.isArray(payload?.data)) {
    return payload.data;
  }
  if (Array.isArray(payload)) {
    return payload;
  }
  return [];
};

const initialState: APSchoolCoveragesState = {
  coverages: [],
  loading: false
};

const apSchoolCoveragesSlice = createSlice({
  name: "apSchoolCoverages",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAPSchoolCoverages.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAPSchoolCoverages.fulfilled, (state, action) => {
      state.coverages = normalizeCoverages(action.payload.data);
      state.loading = false;
    });
    builder.addCase(getAPSchoolCoverages.rejected, (state) => {
      state.loading = false;
    });
  }
});

export default apSchoolCoveragesSlice.reducer;
